import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    Input,
} from '@angular/core';
import {MatSidenav} from "@angular/material/sidenav";
import {filter} from 'rxjs/operators';
import {NavigationStart, Router, RouterEvent, Event} from "@angular/router";
@Component({
    selector: 'burger-menu',
    templateUrl: './burger-menu.html',
    styleUrls: ['./burger-menu.scss'],
    standalone: false
})
export class BurgerMenuComponent implements OnInit {
    @Input() menuPosition = 'start';
    @Input() closeIconClass = 'fa fa-close';
    @Input() openIconClass = 'fa fa-bars';
    @Input() closeBtnClasses = '';
    @Input() openBtnClasses = '';
    _disableAnimation = false;
    @Input() set disableAnimation(value){
        this._disableAnimation = value == 'true';
    }
    _hasBackdrop = true;
    @Input() set hasBackdrop(value){
        this._hasBackdrop = value == 'true';
    }
    _iconOnlyClose: boolean = true;
    @Input() set iconOnlyClose(value){
        this._iconOnlyClose = value == 'true';
    }
     _iconOnlyOpen: boolean = true;
    @Input() set iconOnlyOpen(value){
        this._iconOnlyOpen = value == 'true';
    }
    @Input() closeBtnText = 'Close menu';
    @Input() openBtnText = 'Open menu';
    @Input() burgerClass = '';
    _toggleBtn = false;
    @Input() set toggleBtn(value){
        this._toggleBtn = value == 'true';
    }
    _closeBtnInMenu;
    @Input() set closeBtnInMenu(value){
        this._closeBtnInMenu = value == 'true';
    }
    @ViewChild('sidenav') sidenav: MatSidenav;

    constructor(protected router: Router) {
        this.router.events.pipe(
            filter((e: Event | RouterEvent): e is RouterEvent => e instanceof NavigationStart)
        ).subscribe((e: NavigationStart) => {
            this.sidenav.close();
        });
    }

    ngOnInit() {
    }
}
